// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","335":"api","596":"404","867":"douyin-code-page"}[chunkId] || chunkId) + "." + {"177":"12c29eed","335":"8b8b5896","596":"75413b36","680":"2a6f8fcd","867":"bbae63d6"}[chunkId] + ".css";
};